import { Validators } from '@angular/forms';

export class DocumentDetailsModel {
  documentType = {
    value: null,
    validation: Validators.compose([])
  };

  comments = {
    value: null,
    validation: Validators.compose([])
  };

  files = {
    value: [],
    validation: Validators.compose([])
  };

  securities = {
    value: null,
    validation: Validators.compose([])
  };

  parties = {
    value: null,
    validation: Validators.compose([])
  };
}

export class IndividualDocumentModel {
  documentTypeCode = {
    value: null,
    validation: Validators.compose([])
  };

  comments = {
    value: null,
    validation: Validators.compose([])
  };

  key = {
    value: null,
    validation: Validators.compose([])
  };

  security = {
    value: null,
    validation: Validators.compose([])
  };

  party = {
    value: null,
    validation: Validators.compose([])
  };

  // checksum = {
  //   value: null,
  //   validation: Validators.compose([])
  // };

  description = {
    value: null,
    validation: Validators.compose([])
  };

  origName = {
    value: null,
    validation: Validators.compose([])
  };

}
